import { Button, Input, message, DatePicker, Modal } from 'antd';
import { useState } from 'react';
import couponApi from '@/api/coupon';
import { calendarIcon } from '@/constants/static';
import { disabledDateValidity, numberInput, scrollInto } from '@/utils/publicMethod';
import ConpouCustomerModal from './conpou-customer-modal';
import dayjs from 'dayjs';
import useBack from './useBackPre';
import format from '@/utils/format';
const { RangePicker } = DatePicker;
const validityTypes = ['permanentlyValid', 'validityPeriod', 'validityDays'];
const discountTypes = ['fixedAmount', 'percentage', 'noFees'];
interface CouponParams {
    couponName: string;
    description: string;
    validityType: number; // 有效期类型
    validityDays: string | number; // 有效天数
    beginDate: string;
    endDate: string;
    smsNotification: boolean | null; // 是否发送短信
    notificationMessage: string; // 短信内容
    customerIdList: string[];
    couponDiscountList: {
        type: number; // 折扣类型
        minTask: string | number;
        discount: string | number; // 固定折扣金额 or 折扣百分比
    }[];
}
const OnlineCouponInfo = () => {
    const { onBack } = useBack('OnlineCoupons');
    const [customerModal, setCustomerModal] = useState(false);
    const [tipModal, setTipModal] = useState(false);
    const [selCustomer, setSelCustomer] = useState<any>([]);
    const [state, setState] = useState<CouponParams>({
        couponName: '',
        description: '',
        couponDiscountList: [{ type: -1, minTask: '', discount: '' }],
        validityType: -1,
        beginDate: '',
        endDate: '',
        validityDays: '',
        smsNotification: null,
        notificationMessage: '',
        customerIdList: [],
    });
    const [createing, setCreateing] = useState(false);
    const onFinish = async () => {
        const {
            couponName,
            description,
            validityDays,
            validityType,
            beginDate,
            endDate,
            smsNotification,
            notificationMessage,
            couponDiscountList,
        } = state;
        if (!selCustomer.length) {
            // 未选择customer
            scrollInto('specify-account');
            message.error('Please complete all required information.');
            return;
        }
        const haveNullValueIndex = couponDiscountList.findIndex(
            c =>
                (c.type !== 2 && (!c.minTask || !c.discount || Number(c.minTask) === 0 || Number(c.discount) === 0)) ||
                c.type === -1
        );
        if (haveNullValueIndex > -1) {
            // 未填写正确的优惠信息
            console.log('未填写正确的优惠信息');
            const haveNullValueItem = couponDiscountList[haveNullValueIndex];
            if (!haveNullValueItem.minTask || Number(haveNullValueItem.minTask) === 0) {
                setErrorStyle('', 'min-task-' + haveNullValueIndex);
            } else {
                setErrorStyle('', 'discount-' + haveNullValueIndex);
            }
            return;
        }
        if (validityType === -1) {
            scrollInto('', 'validity-date');
            message.error('Please complete all required information.');
            console.log('未选择过期类型');
            return;
        }
        // 未选择过期时间
        if (validityType === 1 && (!beginDate || !endDate)) {
            setErrorStyle('', 'validity-date');
            console.log('未选择过期时间');
            return;
        }
        // 未选择过期天数
        if (validityType === 2 && !validityDays) {
            setErrorStyle('', 'validity-days');
            console.log('未选择过期天数');
            return;
        }
        if (smsNotification === null) {
            scrollInto('notification-message');
            message.error('Please complete all required information.');
            console.log('未选择是否发送短信');
            return;
        }
        // 未填写短信内容
        if (smsNotification && !notificationMessage) {
            setErrorStyle('notification-message', '');
            console.log('未填写短信内容');
            return;
        }
        const params = {
            couponName,
            description: description.substring(0, 500),
            validityType: validityTypes[validityType],
            validityDays: validityType === 2 ? validityDays : '',
            beginDate,
            endDate,
            smsNotification,
            notificationMessage,
            customerIdList: selCustomer.map(v => v.customerId),
            couponDiscountList: couponDiscountList.map(item => {
                return {
                    discountType: discountTypes[item.type],
                    minTask: Number(item.minTask) * 100,
                    fixedDiscount: !item.type ? Number(item.discount) * 100 : '',
                    percentageDiscount: item.type === 1 ? Number(item.discount) : '',
                };
            }),
        };
        console.log('params', params);
        setCreateing(true);
        try {
            await couponApi.createOnlineCoupon(params);
            onBack();
        } catch (error: any) {
            message.error(error);
            setCreateing(false);
        }
    };
    const setErrorStyle = (id?: string, className?: string, add = true) => {
        if (id) {
            const el = document.getElementById(id);
            el && (add ? el.classList.add('error-input') : el.classList.remove('error-input'));
        }
        if (className) {
            const el = document.getElementsByClassName(className);
            el.length && (add ? el[0].classList.add('error-input') : el[0].classList.remove('error-input'));
        }
        if (add) {
            message.error('Please complete all required information.');
            scrollInto(id, className || '');
        }
    };
    const changeDiscountType = (type, i) => {
        state.couponDiscountList[i].type = type;
        setState({ ...state });
    };
    return (
        <div className="page-main add-coupon">
            {createing && <div className="add-coupon-mask"></div>}
            <div className="page-title">
                <img
                    className="back-icon"
                    src={require('@/assets/images/back-icon.png')}
                    alt="back-icon"
                    onClick={() => onBack(false)}
                />
                Create New Customer Coupon
            </div>
            <div className="add-coupon-form">
                <div>
                    <div className="coupon-tip">Title</div>
                    <Input
                        showCount={format.countFormatter}
                        className="default_input"
                        placeholder="Title"
                        value={state.couponName}
                        onInput={(e: any) => setState({ ...state, couponName: e.target.value })}
                        maxLength={25}
                    />
                </div>
                <div>
                    <div className="coupon-tip">Description</div>
                    <Input.TextArea
                        className="category-notes"
                        maxLength={500}
                        showCount={format.countFormatter}
                        onInput={(e: any) => setState({ ...state, description: e.target.value })}
                        autoSize={{ minRows: 6 }}
                        placeholder="Description"
                    />
                </div>
                <div>
                    <div className="coupon-tip" id="specify-account">
                        Specify Account
                    </div>
                    <div className="flex-left">
                        <div className="flex-center customer-btn" onClick={() => setCustomerModal(true)}>
                            <i className="add-coupon-customer-icon"></i>
                            Select Specify Customers
                        </div>
                        <span className="customer-num">{selCustomer.length || 0} Selected </span>
                    </div>
                </div>
                <div>
                    <div className="coupon-tip">Discount</div>
                    {state.couponDiscountList.map((item, i) => {
                        return (
                            <div className="bg-item" key={`discount-${i}`} style={{ marginBottom: 12 }}>
                                <div className="flex-left">
                                    <div className="flex-left" style={{ width: 632 }}>
                                        <div
                                            className={`sel-item-box flex-left marr24 ${!item.type ? 'checked' : ''}`}
                                            onClick={() => changeDiscountType(0, i)}
                                        >
                                            <i className="radio-icon"></i>
                                            Fixed amount
                                        </div>
                                        <div
                                            className={`sel-item-box flex-left marr24 ${
                                                item.type === 1 ? 'checked' : ''
                                            }`}
                                            onClick={() => changeDiscountType(1, i)}
                                        >
                                            <i className="radio-icon"></i>
                                            Percentage
                                        </div>
                                        <div
                                            className={`sel-item-box flex-left marr24 ${
                                                item.type === 2 ? 'checked' : ''
                                            }`}
                                            onClick={() => changeDiscountType(2, i)}
                                        >
                                            <i className="radio-icon"></i>
                                            No-Fees
                                        </div>
                                    </div>
                                    {i > 0 && (
                                        <div
                                            className="del-coupon-icon"
                                            onClick={() => {
                                                state.couponDiscountList.splice(i, 1);
                                                setState({ ...state });
                                            }}
                                        ></div>
                                    )}
                                </div>
                                {item.type !== -1 && item.type !== 2 && (
                                    <div className="flex-left" style={{ marginTop: 24, width: 632 }}>
                                        <div className="flex-left flex1">
                                            <span className="discount-c-tip">Min Task</span>
                                            <Input
                                                className={`default_input no-border min-task-${i}`}
                                                maxLength={10}
                                                value={item.minTask}
                                                prefix="$"
                                                onInput={(e: any) => {
                                                    const value = numberInput(e.target.value);
                                                    state.couponDiscountList[i].minTask = value;
                                                    setState({ ...state });
                                                }}
                                            />
                                        </div>
                                        <div className="flex-left flex1" style={{ marginLeft: 24 }}>
                                            <span className="discount-c-tip">Discount</span>
                                            <Input
                                                className={`default_input no-border discount-${i}`}
                                                placeholder=""
                                                maxLength={!item.type ? 10 : 3}
                                                prefix={!item.type ? '$' : ''}
                                                suffix={item.type === 1 ? '%' : ''}
                                                onInput={(e: any) => {
                                                    const value = numberInput(
                                                        e.target.value,
                                                        !item.type ? 99999 : 100,
                                                        false
                                                    );
                                                    e.target.value = value;
                                                    state.couponDiscountList[i].discount = value;
                                                    setState({ ...state });
                                                }}
                                                onBlur={e => {
                                                    const value = e.target.value;
                                                    if (item.type === 1 && Number(value) >= 20) {
                                                        setTipModal(true);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                    {state.couponDiscountList.length < 5 && (
                        <div
                            className="add-btn-coupon flex-left"
                            onClick={() => {
                                state.couponDiscountList.push({ type: -1, minTask: '', discount: '' });
                                setState({ ...state });
                            }}
                        >
                            +<span style={{ textDecoration: 'underline', marginLeft: 8 }}>ADD</span>
                        </div>
                    )}
                </div>
                <div>
                    <div className="coupon-tip">Validity period</div>
                    <div>
                        <div>
                            <div
                                className={`sel-item-box flex-left marr24 ${!state.validityType ? 'checked' : ''}`}
                                onClick={() => setState({ ...state, validityType: 0 })}
                            >
                                <i className="radio-icon"></i>
                                Permanently valid
                            </div>
                        </div>
                        <div className="flex-left select-bar" style={{ margin: '24px 0' }}>
                            <div
                                className={`sel-item-box flex-left marr24 ${state.validityType === 1 ? 'checked' : ''}`}
                                onClick={() => setState({ ...state, validityType: 1 })}
                            >
                                <i className="radio-icon"></i>
                                Validity period
                            </div>
                            <RangePicker
                                style={{ width: 290 }}
                                className="search-input validity-date"
                                id="validity-date"
                                placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                                suffixIcon={calendarIcon}
                                separator={'-'}
                                format={'DD/MM/YYYY'}
                                disabledDate={disabledDateValidity}
                                onChange={val => {
                                    const beginDate = val
                                        ? dayjs(`${dayjs(val[0]).format('YYYY-MM-DD')} 00:00:00`).toISOString()
                                        : '';
                                    const endDate = val
                                        ? dayjs(`${dayjs(val[1]).format('YYYY-MM-DD')} 23:59:59`).toISOString()
                                        : '';
                                    setState({ ...state, beginDate, endDate });
                                }}
                            />
                        </div>
                        <div className="flex-left">
                            <div
                                className={`sel-item-box flex-left marr24 ${state.validityType === 2 ? 'checked' : ''}`}
                                onClick={() => setState({ ...state, validityType: 2 })}
                            >
                                <i className="radio-icon"></i>
                                Validity days limit
                            </div>
                            <Input
                                style={{ width: 154 }}
                                className="default_input no-border validity-days"
                                id="validity-days"
                                placeholder=""
                                maxLength={3}
                                suffix="Day(s)"
                                value={state.validityDays}
                                onInput={(e: any) => {
                                    const value = numberInput(e.target.value, 999, false, 1);
                                    setState({ ...state, validityDays: value });
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="coupon-tip">Use SMS Notification</div>
                    <div>
                        <div
                            className={`sel-item-box flex-left marr24 ${
                                !state.smsNotification && state.smsNotification !== null ? 'checked' : ''
                            }`}
                            onClick={() => setState({ ...state, smsNotification: false, notificationMessage: '' })}
                        >
                            <i className="radio-icon"></i>
                            No
                        </div>
                        <div
                            style={{ margin: '24px 0 12px 0' }}
                            className={`sel-item-box flex-left marr24 ${state.smsNotification ? 'checked' : ''}`}
                            onClick={() => setState({ ...state, smsNotification: true })}
                        >
                            <i className="radio-icon"></i>
                            Yes
                        </div>
                        {state.smsNotification && (
                            <Input.TextArea
                                className="category-notes"
                                id="notification-message"
                                maxLength={160}
                                showCount={format.countFormatter}
                                onInput={(e: any) => setState({ ...state, notificationMessage: e.target.value })}
                                onBlur={e => e.target.value && setErrorStyle('notification-message', '', false)}
                                autoSize={{ minRows: 6 }}
                                placeholder="Message"
                            />
                        )}
                    </div>
                </div>
                <div>
                    <div style={{ display: 'flex', marginTop: 24, columnGap: 12 }}>
                        <Button style={{ width: 132 }} onClick={() => onBack(false)} className="cancel-btn bg-f5">
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={() => onFinish()}
                            style={{ width: 194 }}
                            disabled={!state.couponName || !state.description}
                            loading={createing}
                        >
                            Create
                        </Button>
                    </div>
                </div>
            </div>

            {/* customer modal */}
            <ConpouCustomerModal
                customerModal={customerModal}
                defaultCustomers={selCustomer}
                setCustomerModal={val => setCustomerModal(val)}
                addCustomer={val => {
                    setCustomerModal(false);
                    setSelCustomer(val);
                }}
            />

            {/* tip modal */}
            <Modal
                width={440}
                maskClosable={false}
                centered={true}
                open={tipModal}
                onCancel={() => setTipModal(false)}
                closeIcon={<></>}
            >
                <div className="modal-title" style={{ marginTop: 0 }}>
                    Heads Up!
                </div>
                <div className="modal-tip tip-font-16" style={{ margin: '8px 0 0 0' }}>
                    Setting a high discount rate for your coupon may result in additional costs that the platform will
                    need to cover. <br></br>
                    We recommend reviewing the discount amount to avoid unintended platform charges.
                </div>
                <div className="flex-center" style={{ marginTop: 40 }}>
                    <Button style={{ width: 138, height: 46 }} type="primary" onClick={() => setTipModal(false)}>
                        Ok
                    </Button>
                </div>
            </Modal>
        </div>
    );
};
export default OnlineCouponInfo;
